export default [
    {
        path: '/mdm/data-asset-type',
        name: 'mdm-data-asset-type',
        props: { targetPath: '/data-asset-type' },
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/metadata/index',
        name: 'mdm-metadata-index',
        props: { targetPath: '/metadata/index' },
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/metadata/edit',
        name: `bdc-metadata-edit`,
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/metadata/version',
        name: `bdc-metadata-view-version`,
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/fd/index',
        name: `mdm-form-design`,
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/fd/editPage',
        name: "fd-editPage",
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/master-data-monitor-center',
        name: "master-data-monitor-center",
        component: resolve => require(['@/view/mdm/master-data-monitor-center/index.vue'], resolve)
    },
    {
        path: '/mdm/master-data-monitor-center/results',
        name: "master-data-monitor-center-results",
        component: resolve => require(['@/view/mdm/master-data-monitor-center/results.vue'], resolve)
    },
    //workflow
    {
        path: '/mdm/workflow/projects',
        name: 'mdm-workflow-projects',
        props: { targetPath: '/workflow/projects' },
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/workflow/project/add',
        name: 'mdm-workflow-project-add',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/workflow/project/edit',
        name: 'mdm-workflow-project-edit',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/workflow/approval',
        name: 'mdm-workflow-project-approval',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/workflow/my-request',
        name: 'mdm-workflow-project-request-detail',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/scheduled-task/list',
        name: 'mdm-scheduled-task-list',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/scheduled-task/add',
        name: 'mdm-scheduled-task-add',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/scheduled-task/edit',
        name: 'mdm-scheduled-task-edit',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/email-template/list',
        name: 'mdm-email-template-list',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/email-template/add',
        name: 'mdm-email-template-add',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    {
        path: '/mdm/email-template/edit',
        name: 'mdm-email-template-edit',
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
    //数据字典
    {
        path: '/mdm/dict/index',
        name: 'mdm-dict-index',
        props: { targetPath: '/bdc-sys/dict' },
        component: resolve => require(['@/view/mdm/app-container.vue'], resolve)
    },
]


// WEBPACK FOOTER //
// ./src/router/mdm.js